import React from 'react'
import Navbar from '../components/Navbar'
import Footer from '../components/Footer'
import { Link } from 'react-router-dom'
import { Helmet } from 'react-helmet'
import ScrollNavbar from '../components/ScrollNavbar'

const ConfirmBooking = () => {
  return ( 
    <div>
       <Helmet>
      <meta name="robots" content="noindex, nofollow"></meta>
      </Helmet> 

      <ScrollNavbar/>

        <Navbar/>
        <div className="confirm-booking">
        <div className="confirm-booking-heading-1">Your Pet Grooming Service is Booked.</div>
        <div className="confirm-booking-heading-2">Our expert will contact you Soon.</div>
        {/* <div className="confirm-booking-heading-3">Contact : <Link target='blank' to="tel:+91-9658-189-189">+91 9658-189-189</Link></div> */}
 
        <br />
        <div className="confirm-booking-link"><Link onClick={() =>  window.history.back()}>Go Back</Link></div>
        <br />
        <div className="confirm-booking-link"><Link to="tel:+919658189189" target="_blank"><i className="fa-solid fa-phone"></i> Book By Call</Link></div>

        </div>
        <Footer/>
    </div>
  )
}

export default ConfirmBooking